import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { WrapRootElement } from "./src/provider";
import { I18nextProvider } from "react-i18next";
import i18n from "./src/i18n";

// Sous-ensembles latin/latin étendu uniquement (site FR/EN) : évite de charger
// les jeux de caractères cyrillique/vietnamien inutilisés à chaque page.
import '@fontsource/syncopate/latin-400.css';
import '@fontsource/syncopate/latin-ext-400.css';
import '@fontsource/raleway/latin-400.css';
import '@fontsource/raleway/latin-ext-400.css';
import '@fontsource/quicksand/latin-400.css';
import '@fontsource/quicksand/latin-ext-400.css';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <I18nextProvider i18n={i18n}>
    <WrapRootElement element={element} />
  </I18nextProvider>
);
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (location.pathname === '/dev-404-page/') {
    window.location.replace('/404');
  }
};

export const onInitialClientRender = () => {};